import { AppointmentDto, TimeSlotDto, UserDto } from "../api-client";
import { TherapyExt } from "../molecules/Calendar/Calendar.type";
import { layoutSlots, layoutTherapy } from "./slotTherapy";

export const updateReceivedAppointment = (oldAppointment: AppointmentDto, userId: string, start: Date, end: Date) => {
  try {

    let current = new Date(start.getTime()!);

    // Slot layout order and the passive lead-in both come from layoutSlots —
    // the same call the drag ghost makes, so the time the ghost promised at the
    // drop point is the time the layout writes there (MD-314).
    const { ordered: orderedSlots, leadingPassive } = layoutSlots(
      (oldAppointment.timeSlots ?? []) as TimeSlotDto[]
    );

    // Passive preparatory applications (Warmpackung, Heißluft) run before the
    // active treatment, so they shift the appointment start earlier: the main
    // therapy then begins exactly on the drop point.
    const shift = leadingPassive.reduce(
      (acc, timeSlot) => acc - (layoutTherapy(timeSlot)?.duration ?? 0),
      0
    );

    const newAppointment: AppointmentDto = {
      id: oldAppointment.id,
      start: start.toString()!,
      end: end.toString()!,
      frequency: oldAppointment.frequency,
      timeSlots: orderedSlots.map((slot: any) => {
        // The draggable payload carries a duration even for term-only stubs
        // (master-data default via the shelf adapters). Guard anyway: a slot
        // without any usable duration must not NaN the whole layout — 30 is
        // only the last-resort placeholder, the backend clamps to the resolved
        // line item's duration and its survivor DTO wins.
        const rawDuration = Number((layoutTherapy(slot) as TherapyExt | undefined)?.duration);
        const duration = Number.isFinite(rawDuration) && rawDuration > 0 ? rawDuration : 30;
        // console.log("duration:", duration);
        const start = new Date(current.getTime());
        start.setMinutes(start.getMinutes());
        current.setMinutes(current.getMinutes() + duration);
        const end = new Date(current.getTime());
        start.setMinutes(start.getMinutes() + shift);
        end.setMinutes(end.getMinutes() + shift);
        // console.log("start", start, "end", end);
        const timeSlot: TimeSlotDto = {
          id: slot.id,
          user: {id: userId} as UserDto,
          start: start.toISOString(),
          end: end.toISOString(),
          type: slot.type,
          // MD-232 D3: the performed therapy belongs to the SLOT, not the line.
          // Only a resolved line item (has an id) may be sent: slotTherapy() on a
          // term-only slot (fresh, never-scheduled stub) returns display-level
          // term details WITHOUT an id, and the scheduler's slot re-save rejects
          // that payload (EntityPropertyNotFound "therapy.id"). The backend
          // re-resolves the line item on scheduling anyway (correctTimeSlotTherapy).
          therapy: (slot.therapy?.id ? slot.therapy : undefined) as any,
          therapyRx: {
            id: slot.therapyRx.id,
            amount: slot.therapyRx.amount,
            rx: {
              rxNumber: slot.therapyRx.rx.rxNumber,
              id: slot.therapyRx.rx.id,
              patientId: slot.therapyRx.rx.patientId,
            },
          },
        };
        return timeSlot;
      }),
    };
    // console.log("Appointment to save", newAppointment);
    return newAppointment;
  } catch (error) {
    console.error("Error in createAppointment:", error);
    return null;
  };
}